export function uniqueById<T extends { _id: string }>(items: T[]): T[] {
  const seen = new Set<string>();
  return items.filter(item => !seen.has(item._id) && seen.add(item._id));
}
